// extracted by mini-css-extract-plugin
export default {"container":"logo_container__91NNL","text":"logo_text__Gda+v"};